'use client';

import { useFormStatus } from 'react-dom';
import Button from '@/components/common/Button';
import { ButtonHTMLAttributes } from 'react';

interface SubmitButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'type'> {
  children?: React.ReactNode;
  loadingText?: string;
  buttonType?: 'primary' | 'secondary' | 'text' | 'disable';
  buttonSize?: 'mid' | 'sm';
}

export default function SubmitButton({
  children = '送信する',
  loadingText = '処理中...',
  buttonType = 'primary',
  buttonSize = 'mid',
  className,
  ...props
}: SubmitButtonProps) {
  const { pending } = useFormStatus();

  return (
    <Button
      type="submit"
      buttonType={buttonType}
      size={buttonSize}
      isLoading={pending}
      loadingText={loadingText}
      className={className}
      {...props}
    >
      {children}
    </Button>
  );
}
